export function getReferrerDomain() {
	if (document.referrer) {
		try {
			const referrerUrl = new URL(document.referrer);
			return referrerUrl.hostname;
		} catch (e) {
			return null;
		}
	}
}
